export default __webpack_public_path__ + "static/media/bitballoon.2194dfb4.svg";